import { useIntl } from "react-intl";

import {
    EnterpriseTabsWithCards,
    TabsDataType
} from "@/components/enterprise/enterprise-hero-v2/src/enterprise-tabs-with-cards";

import { AnalystsTabContent } from "./hero-tab-contents/analysts";
import { EnterpriseTabContent } from "./hero-tab-contents/enterprise";
import { ProductTabContent } from "./hero-tab-contents/product";

export const ENTERPRISE_HERO_TAB_INTERVAL = 8000;

export const HeroV2Section = () => {
    const intl = useIntl();

    const tabs: TabsDataType = [
        {
            tabComponent: <EnterpriseTabContent />,
            title: intl.formatMessage({
                id: "EnterpriseLandingPage.tab.label.enterprise",
                defaultMessage: "Enterprise"
            }),
            caption: intl.formatMessage({
                id: "EnterpriseLandingPage.tab.label.enterprise.caption",
                defaultMessage: "Atlassian’s System of Work"
            }),
            englishLabel: "enterprise",
            id: "enterprise"
        },
        {
            tabComponent: <ProductTabContent />,
            title: intl.formatMessage({
                id: "EnterpriseLandingPage.tab.label.product",
                defaultMessage: "Product"
            }),
            caption: intl.formatMessage({
                id: "EnterpriseLandingPage.tab.label.product.caption",
                defaultMessage: "Atlassian’s latest AI innovation"
            }),
            englishLabel: "product",
            id: "product"
        },
        {
            tabComponent: <AnalystsTabContent />,
            title: intl.formatMessage({
                id: "EnterpriseLandingPage.tab.label.analysts",
                defaultMessage: "Analysts"
            }),
            caption: intl.formatMessage({
                id: "EnterpriseLandingPage.tab.label.analysts.caption",
                defaultMessage: "Gartner Magic Quadrant Leader"
            }),
            englishLabel: "analysts",
            id: "analysts"
        }
    ];

    return (
        <EnterpriseTabsWithCards
            tabsData={tabs}
            tabSwitchInterval={ENTERPRISE_HERO_TAB_INTERVAL}
        />
    );
};
